import { FC } from 'react';
import { TableProps } from 'antd';
import { Fx, Layout, Table } from 'Components';
import { DownloadReportButton, LayoutHolder } from 'Pages/Dashboard/components';
import { OverviewGroupSummary } from 'Services/Api/Dashboard/Types';
import { getGroupSummaryColumns } from './columns';
import Heading from '../components/Heading';
import Button from '../components/Button';
import styles from './GroupSummaryTable.module.scss';
import { ReportType } from 'Services/Api/Reports/Types';

interface GroupSummaryTableProps {
	data?: OverviewGroupSummary[];
	loading?: boolean;
	title?: string;
	onChange?: TableProps<OverviewGroupSummary>['onChange'];
	onDownload?: () => void;
}

const GroupSummaryTable: FC<GroupSummaryTableProps> = ({
	data = [],
	loading = false,
	title = 'Group Summary',
	onChange,
	onDownload
}) => {
	return (
		<LayoutHolder className={styles.tableHolder}>
			<Layout>
				<Layout.Heading className={styles.heading}>
					<Fx align="middle" justify="space-between">
						<Heading title={title} />
						<DownloadReportButton
							reportType={ReportType.OverviewGroupSummary}
						/>
					</Fx>
				</Layout.Heading>
				<Table<OverviewGroupSummary>
					className={styles.table}
					rowKey="groupName"
					dataSource={data}
					columns={getGroupSummaryColumns()}
					pagination={false}
					loading={loading}
					onChange={onChange}
				/>
			</Layout>
		</LayoutHolder>
	);
};

export default GroupSummaryTable;
